import React, {useContext, useEffect, useState} from "react";
import {Context} from "../../../App";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Breadcrumb, Card, Descriptions, Divider, Skeleton, Space, Table, Tooltip,} from "antd";
import moment from "moment";
import BackButton from "../../tech/back_button";
import DB_LogMobile from "../../../database/development/log_mobile";

const LogMobile = () => {
    const {session_id} = useParams()
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getLogMobile} = DB_LogMobile(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const p = new URLSearchParams(window.location.search)
    const location = useLocation()
    const path = location.state == null ? null : (location.state.path == null ? null : location.state.path)
    const from = location.state == null ? null : (location.state.from == null ? null : location.state.from)
    const controller = new AbortController()
    const [wait, setWait] = useState(false)
    const [openDrawerTradePoint, setOpenDrawerTradePoint] = useState(false)


    let [data, setData] = useState({
        date: null,
        org_structure: null,
        platform: null,
        version_platform: null,
        version_app: null,
        lang_platform: null,
        details: []
    })



    const columns = [
        {
            title: t('type'),
            dataIndex: 'type',
            render: (type) => <>{t(type)}</>
        },
        {
            title: t('request_status'),
            dataIndex: 'code_response',
            render: (code, record) =>
                <Tooltip placement={'bottom'} title={record.descriptions}>
                    <span style={code === 200 ? {color:"black"} : {color:"red"}}>{t(code)}</span>
                </Tooltip>
        },
        {
            title: t('response_time'),
            dataIndex: 'response_time'
        }
    ]

    useEffect(() => {
        window.scroll(0, 0)
        if (wait) {
            controller.abort()
        }
        if (session_id != null) {
            setWait(true)
            getLogMobile(controller, session_id)
                .then(res => {
                    setData(res.data)
                    setWait(false);
                })
                .catch((e) => {
                    if (!axios.isCancel(e)) {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    }
                })
        }
    }, [])


    return (
        <>
            <div className="page">
                <Space
                    style={{
                        width: '100%',
                        justifyContent: 'space-between'
                    }}>
                    <Breadcrumb
                        style={{
                            margin: '15pt 0',
                        }}
                    >
                        <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('sync_log')}</span>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Space>
                        <BackButton/>
                    </Space>
                </Space>
                <Card
                    title={<>{t('session_id')} <br/> {session_id}</>}
                >
                    <Skeleton loading={wait} active>
                        <Descriptions>

                            <Descriptions.Item label={t('date')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{moment.utc(data.date).format("DD.MM.YYYY HH:mm")}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('org_structure')} span={3}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{t(data.org_structure)}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('platform')} span={1} >
                                <span style={{fontFamily: 'Montserrat-Medium'}} >{data.platform}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('version_platform')} span={2}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.version_platform}</span>
                            </Descriptions.Item>




                            <Descriptions.Item label={t('version_app')} span={1}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.version_app}</span>
                            </Descriptions.Item>

                            <Descriptions.Item label={t('lang_platform')} span={1}>
                                <span style={{fontFamily: 'Montserrat-Medium'}}>{data.lang_platform}</span>
                            </Descriptions.Item>

                        </Descriptions>
                    </Skeleton>
                    <Divider/>

                    <Table
                        style={{'--cursor': "auto" }}
                        columns={columns}
                        dataSource={data.details}
                        rowKey="id"
                        loading={wait}
                        pagination={false}
                        size={"small"}
                    />


                </Card>
            </div>
            <Outlet/>
        </>
    )
}

export default LogMobile